import { useTheme } from '@mui/material';

export const NewCompensationIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} fill="none">
            <path
                fill={primaryStroke}
                d="M25 10v.6c.369.063 1.188.219 1.506.306l.969.256-.513 1.932-.968-.256a22.49 22.49 0 0 0-1.381-.275c-.8-.126-1.476-.026-1.932.18-.45.207-.619.47-.656.688-.044.257-.006.388.031.463.038.087.125.194.313.319.419.287 1.069.487 1.937.75l.038.012c.768.231 1.743.525 2.468 1.056.394.282.75.663.976 1.175.224.519.274 1.088.168 1.7-.187 1.094-.912 1.838-1.831 2.232-.35.15-.725.25-1.119.306V23h-2v-1.6c-.587-.106-1.475-.412-2.025-.6a7.077 7.077 0 0 1-.287-.1l-.95-.319.631-1.9.95.319c.119.037.25.081.381.131.594.2 1.294.438 1.694.506.831.132 1.5.05 1.938-.137.406-.175.593-.419.643-.738.05-.293.013-.456-.031-.562-.044-.106-.137-.225-.319-.356-.406-.3-1.044-.506-1.906-.769l-.125-.038c-.744-.224-1.663-.5-2.356-.968-.388-.263-.763-.625-.994-1.119-.238-.506-.294-1.069-.194-1.662.181-1.044.919-1.775 1.8-2.17A4.26 4.26 0 0 1 23 10.582V9h2v1Zm-8.3 17H31v5h.012l6.475-3.856.844-.5.519.831 2.5 4 .525.837-.844.532-9.5 6-.243.156H6v-2h24.712l8.413-5.313-1.456-2.324-5.875 3.5-.232.137H21v-2h8v-3H17.3l-5.75 3.831-.25.169H6v-2h4.7l5.75-3.831.25-.169Z"
            />
        </svg>
    );
};
